import UserOtherHistoryOperations from './UserOtherHistoryOperations'

export default UserOtherHistoryOperations
